var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('AssetsCatalogTable',{attrs:{"items":_vm.assets,"pagination-data":_vm.pagination,"hover":"","striped":"","border":"","small":"","fixed":"","caption":"Inventario de Activos"},on:{"refreshItems":_vm.refreshItems}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }